// extracted by mini-css-extract-plugin
export default {"tooltip":"aV-z","arrow":"bV-z"};